export const STATE_MENU = {
  CURRENT: 'CURRENT',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};
